module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8NP9w"))).then(() => module.bundle.root('ewmtE'));